export var defaultSchema = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target"
};
//# sourceMappingURL=schema.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@stimulus/core/dist/schema.js
// module id = null
// module chunks = 